import callApiAxiosClient from "../../axios/axios_client";
import moment from "moment";
import { missingProductList } from "../../models";


async function bakeryMissingProduct(locationId: number, date: Date | undefined, fromHour: number, toHour: number): Promise<missingProductList> {
    const token = JSON.parse(localStorage.getItem('user')!)
    const dateParam = moment(date).format("YYYYMMDD");
    const authorization = 'Bearer ' + token.token
    return callApiAxiosClient<missingProductList>({
        method: "get",
        url: "programmability/missing-product",
        headers: {
            "Content-Type": "Application/json",
            "Authorization": authorization

        },
        params: {
            locationId: locationId,
            date: dateParam,
            fromHour: fromHour,
            toHour: toHour,
        }
    })
}
export default bakeryMissingProduct;